import React from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { useMediaQuery } from '@material-ui/core';

import { useScreenHeight } from '../../hooks/useScreenHeight';
import { MobileScreenWrapper } from '../MobileScreenWrapper/MobileScreenWrapper';
import { Header } from './Header/Header';
import { Sidebar } from './Sidebar';

const LOCAL_STORAGE_KEY = 'beautypassAdmin:sidebarLocked';

export const Layout: React.FC = ({ children }) => {
  const location = useLocation();
  const screenHeight = useScreenHeight();
  const isMobileScreen = useMediaQuery('(max-width:486px)');

  const [sidebarLocked, setSidebarLocked] = React.useState(
    localStorage.getItem(LOCAL_STORAGE_KEY) === 'true',
  );

  const toggleSidebarLocked = React.useCallback(() => {
    localStorage.setItem(LOCAL_STORAGE_KEY, String(!sidebarLocked));
    setSidebarLocked(!sidebarLocked);
  }, [sidebarLocked]);

  return (
    <>
      {location.pathname.includes('event-report') ? (
        <>{children}</>
      ) : (
        <>
          {isMobileScreen ? (
            <MobileScreenWrapper>{children}</MobileScreenWrapper>
          ) : (
            <>
              <Header />
              <Sidebar sidebarLocked={sidebarLocked} toggleSidebarLocked={toggleSidebarLocked} />

              <ContentWrapper sidebarLocked={sidebarLocked} screenHeight={screenHeight}>
                {children}
              </ContentWrapper>
            </>
          )}
        </>
      )}
    </>
  );
};

const ContentWrapper = styled.div<{ screenHeight: number; sidebarLocked: boolean }>`
  ${({ screenHeight, sidebarLocked, theme }) => `
  flex-flow: row nowrap;
  display: flex;
  margin-left: ${sidebarLocked ? theme.sizes.sidebarWidth : theme.sizes.shrinkedSidebarWidth};
  min-height: ${screenHeight}px;
  transition: all 100ms ease-in-out;
  padding-top: ${theme.sizes.headerHeight};
`}
`;
